import { Divider } from "../../dataDisplay/Divider";

export const MenuDivider = () => {
	return <Divider hideOnMobile={false} className="py-2" />;
};
